<template>
  <table class="table table-hover">
    <thead>
      <th>Číslo objednávky</th>
      <th>Datum a čas</th>
      <th>Název</th>
      <th>Kupující</th>
      <th>Forma dopravy</th>
      <th>Forma uhrady</th>
      <th>Cena</th>
      <th>Stav</th>
    </thead>
    <tbody>
      <tr v-for="order in orders" :key="order.id">
        <td>
          <a :href="`/orders/${order.id}`">{{ order.formated_id }}</a>
        </td>
        <td>
          {{ moment(order.created_at).format('D.M.Y HH:mm') }}
        </td>
        <td>
          <a :href="`/orders/${order.id}`">{{ order.product.title }}</a>
        </td>
        <td>{{ order.user.firstname }} {{ order.user.lastname }}</td>
        <td>
          {{ order.user_form_delivery ? order.user_form_delivery.name : '' }}
        </td>
        <td>
          {{ order.user_form_payment ? order.user_form_payment.name : '' }}
        </td>
        <td>{{ order.price }},-</td>
        <td>
          {{ order.status }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  export default {
    props: {
      orders: {
        type: Array,
        required: true
      }
    }
  }
</script>
